var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid place-items-center min-h-[120px]"},[_c('div',{staticClass:"lds-grid"},[_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div')]),_c('p',{staticClass:"font-medium uppercase text-center text-lg md:text-xl text-prime-color font-sans"},[_vm._v("Đang tìm kiếm dữ liệu...")])])
}]

export { render, staticRenderFns }